import { IActivityHistoryItem, IActivityHistoryItemCollection } from "./model";

/**
 * Checks if an item with the given ID already exists in the specified collection
 * @param collections - Record of all activity history collections
 * @param entityId - The collection ID to check in
 * @param itemId - The item ID to check for
 * @returns true if the item exists in the collection, false otherwise
 */
export const existItemInCollection = (
  collections: Record<string, IActivityHistoryItemCollection>,
  entityId: string,
  itemId: string,
): boolean => {
  const collection = collections?.[entityId];
  if (!collection?.items) {
    return false;
  }

  return collection.items.some((existingItem: IActivityHistoryItem) => existingItem.id === itemId);
};
